import { useState } from "react";
import "../css/faq.css";
import { FaChevronDown, FaSearch } from "react-icons/fa";

function FAQ() {
  const faqs = [
    {
      question: "How do I place an order?",
      answer:
        "Browse our products, add your favorite items to the cart, proceed to checkout, and complete your payment securely.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept Visa, MasterCard, PayPal, Stripe, and other secure online payment methods.",
    },
    {
      question: "How long does shipping take?",
      answer:
        "Orders are typically processed within 1–2 business days. Delivery times vary depending on your location.",
    },
    {
      question: "Can I cancel my order?",
      answer:
        "Yes. Orders can be cancelled before they are shipped. Once shipped, please refer to our Return Policy.",
    },
    {
      question: "How can I track my order?",
      answer:
        "Go to the Track Order page, enter your Order ID and Email Address to view the latest order status.",
    },
    {
      question: "Do you offer same-day delivery?",
      answer:
        "Same-day delivery may be available in selected locations depending on product availability.",
    },
    {
      question: "Do I need to verify my age?",
      answer:
        "Yes. Customers purchasing alcoholic beverages must meet the legal drinking age and may be required to provide valid ID.",
    },
    {
      question: "What if my product arrives damaged?",
      answer:
        "Please contact our support team within 24 hours with photos of the damaged product so we can assist you.",
    },
    {
      question: "How do I contact customer support?",
      answer:
        "You can reach us via our Contact page, email, or phone during business hours.",
    },
    {
      question: "Can I return my order?",
      answer:
        "Eligible products may be returned according to our Return Policy. Certain products may not be eligible.",
    },
  ];

  const [active, setActive] = useState(null);
  const [search, setSearch] = useState("");

  const filtered = faqs.filter(
    (item) =>
      item.question.toLowerCase().includes(search.toLowerCase()) ||
      item.answer.toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <div className="faq-page">

      {/* Hero */}

      <section className="faq-hero">

        <div className="faq-overlay">

          <h1>Frequently Asked Questions</h1>

          <p>
            Find answers to the most common questions about shopping,
            payments, shipping, returns, and more.
          </p>

          <div className="faq-search">

            <FaSearch />

            <input
              type="text"
              placeholder="Search a question..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

          </div>

        </div>

      </section>

      {/* FAQ */}

      <section className="faq-section">

        <div className="faq-container">

          {filtered.length === 0 && (
            <h3 className="no-result">
              No matching questions found.
            </h3>
          )}

          {filtered.map((faq, index) => (

            <div
              className={`faq-card ${
                active === index ? "active" : ""
              }`}
              key={index}
            >

              <button
                className="faq-question"
                onClick={() => toggle(index)}
              >

                <span>{faq.question}</span>

                <FaChevronDown
                  className={`arrow ${
                    active === index ? "rotate" : ""
                  }`}
                />

              </button>

              <div
                className={`faq-answer ${
                  active === index ? "show" : ""
                }`}
              >

                <p>{faq.answer}</p>

              </div>

            </div>

          ))}

        </div>

      </section>

      {/* Bottom */}

      <section className="faq-contact">

        <h2>Still Need Help?</h2>

        <p>
          Our customer support team is available to answer your questions.
        </p>

        <a href="/contact" className="faq-btn">
          Contact Us
        </a>

      </section>

    </div>
  );
}

export default FAQ;